import React from 'react';
import './StarlinkTracker.scss';

const StarlinkTracker: React.FC = () => {
  return (
    <section id="starlink-tracker" className="starlink-tracker">
      <div className="container">
        <div className="starlink-content">
          <div className="starlink-text">
            <h2>Meet the Starlink Tracker</h2>
            <p className="subtitle">Professional Fleet Management & Visible Security</p>
            
            <div className="features-grid">
              <div className="feature">
                <div className="feature-icon">🔌</div>
                <h3>Hardwired Installation</h3>
                <p>Direct connection to vehicle's electrical system for reliable power and tamper detection</p>
              </div>
              
              <div className="feature">
                <div className="feature-icon">📊</div>
                <h3>Fleet Management</h3>
                <p>Track trips, monitor speeding, detect excessive acceleration and harsh handling</p>
              </div>
              
              <div className="feature">
                <div className="feature-icon">⚡</div>
                <h3>Real-Time Alerts</h3>
                <p>Instant notifications for company vehicle violations and unauthorized usage</p>
              </div>
              
              <div className="feature">
                <div className="feature-icon">🛡️</div>
                <h3>Visible Deterrent</h3>
                <p>Acts as the first line of defense - thieves will target this device first</p>
              </div>
            </div>
          </div>
          
          <div className="starlink-visual">
            <div className="device-showcase">
              <img src="/starlink-device.png" alt="Starlink Tracker Device" className="device-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StarlinkTracker;
